import { Modal } from 'antd'
import React from 'react'
import * as MODAL from 'constant/modal'
import * as NUMBER from 'constant/number'

const { confirm } = Modal

const differenceContent = (decide, differences) => {
  return (
    <>
      {Object.keys(differences).length > NUMBER.ZERO
      ? (
          <ul>
            {Object.keys(differences).map((differenceKey, index) => {
              return (
                <li
                  key={index}
                  style={{ 'text-transform': 'capitalize' }}
                >
                  {differenceKey.replace(/_/g, ' ')}
                </li>)
            })}
          </ul>
        )
        : (
        <p>No changes made</p>
      )}
      <p>{decide.content}</p>
    </>
  )
}

const confirmModalDifferences = (handleSubmit, decide, differences) =>
  confirm({
    cancelText: MODAL.DECIDE.CANCEL_TEXT,
    centered: true,
    content: differenceContent(decide, differences),
    okText: MODAL.DECIDE.OK_TEXT,
    onOk: () => {
      handleSubmit()
    },
    title: decide.title
  })

export default confirmModalDifferences
